/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDobbiesCustomInlineScriptViewProps } from './dobbies-custom-inline-script';

export default (props: IDobbiesCustomInlineScriptViewProps) => {
    return <></>;
};
